// =============================================
// INSTAGRAM FEED — @institutocindy
//
// HOW TO GET YOUR ACCESS TOKEN (one-time setup):
// 1. Go to https://developers.facebook.com/ → Create App → Consumer
// 2. Add "Instagram Basic Display" product
// 3. In Instagram Basic Display → Add Instagram Test User → add @institutocindy
// 4. Under "User Token Generator" → Generate Token for @institutocindy
// 5. Exchange for a long-lived token (valid 60 days, auto-refreshable):
//    GET https://graph.instagram.com/access_token
//      ?grant_type=ig_exchange_token
//      &client_id={app-id}
//      &client_secret={app-secret}
//      &access_token={short-lived-token}
// 6. Paste the long-lived token below.
//
// To refresh before expiry:
//    GET https://graph.instagram.com/refresh_access_token
//      ?grant_type=ig_refresh_token&access_token={long-lived-token}
// =============================================

(function () {
  var ACCESS_TOKEN = 'REMPLACER_PAR_LE_TOKEN'; // ← coller ici le long-lived token

  var grid       = document.getElementById('insta-grid');
  var loadBtn    = document.getElementById('insta-load-more');
  var BATCH      = 6; // visible initially
  var allCards   = [];

  // ── Fallback static load-more (used when no API token) ──────────────────
  function initStaticGrid() {
    if (!loadBtn) return;
    loadBtn.addEventListener('click', function () {
      document.querySelectorAll('.insta-card.is-hidden').forEach(function (c) {
        c.classList.remove('is-hidden');
      });
      loadBtn.classList.add('is-done');
    });
  }

  // ── Build a card DOM element from an API post object ────────────────────
  var igIconSVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>';

  function makeCard(post) {
    var imgSrc = post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url;
    if (!imgSrc) return null;

    var a = document.createElement('a');
    a.href = post.permalink;
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'insta-card';
    a.setAttribute('aria-label', 'Photo @institutocindy sur Instagram');

    var img = document.createElement('img');
    img.src = imgSrc;
    img.alt = post.caption ? post.caption.slice(0, 80) : '';
    img.loading = 'lazy';

    var overlay = document.createElement('div');
    overlay.className = 'insta-card__overlay';
    overlay.innerHTML = igIconSVG + '<span>Voir sur Instagram</span>';

    a.appendChild(img);
    a.appendChild(overlay);
    return a;
  }

  // ── Render paginated cards with load-more ───────────────────────────────
  function renderCards(posts) {
    if (!grid) return;
    grid.innerHTML = '';
    allCards = posts.map(makeCard).filter(Boolean);

    allCards.forEach(function (card, i) {
      if (i >= BATCH) card.classList.add('is-hidden');
      grid.appendChild(card);
    });

    if (!loadBtn) return;
    if (allCards.length <= BATCH) {
      loadBtn.classList.add('is-done');
      return;
    }
    loadBtn.classList.remove('is-done');
    loadBtn.addEventListener('click', function () {
      grid.querySelectorAll('.insta-card.is-hidden').forEach(function (c) {
        c.classList.remove('is-hidden');
      });
      loadBtn.classList.add('is-done');
    });
  }

  // ── Fetch from Instagram Basic Display API ───────────────────────────────
  function fetchFeed() {
    var url = 'https://graph.instagram.com/me/media'
      + '?fields=id,media_type,media_url,thumbnail_url,permalink,caption'
      + '&limit=12'
      + '&access_token=' + ACCESS_TOKEN;

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data.data || !data.data.length) {
          initStaticGrid();
          return;
        }
        renderCards(data.data);
      })
      .catch(function () {
        // Token invalid or expired — fall back to static placeholder grid
        initStaticGrid();
      });
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  if (!grid) return;

  if (ACCESS_TOKEN && ACCESS_TOKEN !== 'REMPLACER_PAR_LE_TOKEN') {
    fetchFeed();
  } else {
    // No token configured → use the static placeholder cards
    initStaticGrid();
  }
})();
